// Keyed by the API's leadScoreLabel. An unlisted label still renders - the
// badge just falls back to neutral styling.
export const statusStyles = {
  Hot: { bg: "#fee2e2", color: "#dc2626", dot: "#ef4444" },
  "Hot lead": { bg: "#fee2e2", color: "#dc2626", dot: "#ef4444" },
  Qualified: { bg: "#ffedd5", color: "#c2410c", dot: "#f97316" },
  Interested: { bg: "#fef3c7", color: "#b45309", dot: "#eab308" },
  New: { bg: "#e8e9fd", color: "#3f44e8", dot: "#3f44e8" },
  Support: { bg: "#e0f2fe", color: "#0369a1", dot: "#0ea5e9" },
  Spam: { bg: "#f3f4f6", color: "#6b7280", dot: "#9ca3af" },
};

export const avatarColors = {
  green: "#22c55e",
  amber: "#f59e0b",
  indigo: "#3f44e8",
  navy: "#1e3a8a",
  pink: "#ec4899",
  teal: "#14b8a6",
  rose: "#f43f5e",
};

export const conversations = [
  {
    id: 1,
    name: "James Doe",
    initials: "JD",
    color: "green",
    online: true,
    time: "2m ago",
    preview: "Hi, I'm looking for a plan for my sales team of 12 people.",
    tags: ["Team Plan", "Pricing", "Demo Request"],
    status: "Hot lead",
    lead: {
      email: "james@acmecorp.com",
      phone: "+1 (212) 555-0148",
      company: "Acme Corp",
      jobTitle: "Sales Manager",
      location: "New York, USA",
      website: "www.acme.com",
      score: 92,
      firstSeen: "May 20, 10:32 AM",
      sourcePage: "/pricing",
      utmSource: "google",
      device: "Desktop",
      qualified: {
        "Team size": "11 - 20",
        Timeline: "This month",
        Budget: "$10k - $20k",
        "Interested in": "Team Plan, Integrations",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "James", time: "10:32 AM", text: "Hi, I'm looking for a plan for my sales team of 12 people." },
      {
        sender: "Maya",
        time: "10:32 AM",
        text: "Great! We have a Business plan that's perfect for growing teams. It includes advanced features, team collaboration and priority support. Would you like me to share the pricing details?",
      },
      { sender: "James", time: "10:33 AM", text: "Yes, please. Also, can we try a demo before deciding?" },
      {
        sender: "Maya",
        time: "10:33 AM",
        text: "Absolutely! Here are the pricing details for the Business plan:",
        plan: {
          name: "Business Plan",
          price: "$79",
          period: "user / month",
          features: ["Unlimited projects", "Team collaboration", "CRM Integrations", "Priority support"],
        },
      },
    ],
    event: { text: "Lead captured", time: "10:34 AM", detail: "James's email was captured." },
  },
  {
    id: 2,
    name: "Sarah Chen",
    initials: "SC",
    color: "amber",
    online: true,
    time: "15m ago",
    preview: "Can you tell me more about the Business plan features?",
    tags: ["Features", "Business Plan"],
    status: "Qualified",
    lead: {
      email: "sarah.chen@brightly.io",
      phone: "+1 (415) 555-0121",
      company: "Brightly Inc.",
      jobTitle: "Product Manager",
      location: "San Francisco, USA",
      website: "www.brightly.io",
      score: 74,
      firstSeen: "May 20, 10:10 AM",
      sourcePage: "/features",
      utmSource: "linkedin",
      device: "Mobile",
      qualified: {
        "Team size": "6 - 10",
        Timeline: "Next quarter",
        Budget: "$5k - $10k",
        "Interested in": "Business Plan",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "Sarah", time: "10:09 AM", text: "Can you tell me more about the Business plan features?" },
      {
        sender: "Maya",
        time: "10:10 AM",
        text: "Sure! The Business plan includes unlimited projects, team collaboration tools, CRM integrations and priority support.",
      },
    ],
    event: null,
  },
  {
    id: 3,
    name: "Ravi Warrier",
    initials: "RW",
    color: "indigo",
    online: false,
    time: "1h ago",
    preview: "Do you integrate with HubSpot?",
    tags: ["Integrations"],
    status: "Support",
    lead: {
      email: "ravi.w@northpeak.co",
      phone: "+91 98765 43210",
      company: "Northpeak Co.",
      jobTitle: "RevOps Lead",
      location: "Bengaluru, India",
      website: "www.northpeak.co",
      score: 58,
      firstSeen: "May 20, 9:20 AM",
      sourcePage: "/integrations",
      utmSource: "direct",
      device: "Desktop",
      qualified: {
        "Team size": "20+",
        Timeline: "Researching",
        Budget: "Not specified",
        "Interested in": "Integrations",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "Ravi", time: "9:20 AM", text: "Do you integrate with HubSpot?" },
      { sender: "Maya", time: "9:21 AM", text: "Yes! Hostor connects with HubSpot out of the box under Settings > Integrations." },
    ],
    event: null,
  },
  {
    id: 4,
    name: "Michael Brown",
    initials: "MB",
    color: "navy",
    online: true,
    time: "2h ago",
    preview: "I'd like to schedule a demo for next week.",
    tags: ["Demo Request", "Calendar"],
    status: "Hot lead",
    lead: {
      email: "michael.brown@vertexlabs.com",
      phone: "+1 (312) 555-0199",
      company: "Vertex Labs",
      jobTitle: "Founder",
      location: "Chicago, USA",
      website: "www.vertexlabs.com",
      score: 88,
      firstSeen: "May 20, 8:05 AM",
      sourcePage: "/demo",
      utmSource: "google",
      device: "Desktop",
      qualified: {
        "Team size": "1 - 5",
        Timeline: "This week",
        Budget: "$1k - $5k",
        "Interested in": "Demo, Onboarding",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "Michael", time: "8:05 AM", text: "I'd like to schedule a demo for next week." },
      { sender: "Maya", time: "8:06 AM", text: "I'd love to set that up! What day works best for you?" },
    ],
    event: { text: "Lead captured", time: "8:07 AM", detail: "Michael's email was captured." },
  },
  {
    id: 5,
    name: "Alice Lee",
    initials: "AL",
    color: "pink",
    online: false,
    time: "3h ago",
    preview: "What is the difference between the plans?",
    tags: ["Pricing"],
    status: "Interested",
    lead: {
      email: "alice.lee@studiofive.design",
      phone: "+1 (646) 555-0110",
      company: "Studio Five",
      jobTitle: "Operations Manager",
      location: "Austin, USA",
      website: "www.studiofive.design",
      score: 41,
      firstSeen: "May 20, 7:40 AM",
      sourcePage: "/pricing",
      utmSource: "twitter",
      device: "Mobile",
      qualified: {
        "Team size": "1 - 5",
        Timeline: "Just browsing",
        Budget: "Not specified",
        "Interested in": "Pricing",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "Alice", time: "7:40 AM", text: "What is the difference between the plans?" },
      { sender: "Maya", time: "7:41 AM", text: "Great question! Our Starter, Business and Enterprise plans differ mainly in usage limits and support level." },
    ],
    event: null,
  },
  {
    id: 6,
    name: "Tom Kline",
    initials: "TK",
    color: "teal",
    online: false,
    time: "5h ago",
    preview: "Our company uses Salesforce, does it work?",
    tags: ["Integrations"],
    status: "Interested",
    lead: {
      email: "tom.kline@bluepeak.com",
      phone: "+1 (206) 555-0177",
      company: "Bluepeak",
      jobTitle: "Sales Ops",
      location: "Seattle, USA",
      website: "www.bluepeak.com",
      score: 52,
      firstSeen: "May 20, 5:55 AM",
      sourcePage: "/integrations",
      utmSource: "google",
      device: "Desktop",
      qualified: {
        "Team size": "11 - 20",
        Timeline: "Next quarter",
        Budget: "$5k - $10k",
        "Interested in": "Salesforce integration",
      },
    },
    date: "May 20, 2024",
    messages: [
      { sender: "Tom", time: "5:55 AM", text: "Our company uses Salesforce, does it work?" },
      { sender: "Maya", time: "5:56 AM", text: "Yes, Hostor integrates with Salesforce so leads sync automatically." },
    ],
    event: null,
  },
  {
    id: 7,
    name: "Priya Patel",
    initials: "PP",
    color: "rose",
    online: false,
    time: "1d ago",
    preview: "Thanks! That answered my question.",
    tags: [],
    status: "Support",
    lead: {
      email: "priya.patel@nimbus.app",
      phone: "+1 (778) 555-0142",
      company: "Nimbus App",
      jobTitle: "Customer Success",
      location: "Vancouver, Canada",
      website: "www.nimbus.app",
      score: 35,
      firstSeen: "May 19, 4:12 PM",
      sourcePage: "/help",
      utmSource: "direct",
      device: "Desktop",
      qualified: {
        "Team size": "6 - 10",
        Timeline: "Not applicable",
        Budget: "Not applicable",
        "Interested in": "Support",
      },
    },
    date: "May 19, 2024",
    messages: [
      { sender: "Priya", time: "4:10 PM", text: "How do I reset my widget's welcome message?" },
      { sender: "Maya", time: "4:11 PM", text: "You can update it under Customization > Behavior & display." },
      { sender: "Priya", time: "4:12 PM", text: "Thanks! That answered my question." },
    ],
    event: null,
  },
];

export const filterTabs = [
  { label: "All" },
  { label: "Hot leads" },
  { label: "Qualified" },
  { label: "Interested" },
  { label: "Support" },
  { label: "Spam" },
];
